import { ReactNode } from 'react';
import styles from './Card.module.css';
import { Stack } from '@mui/material';
import { AuthentigateLogoBase64 } from '../../assets/images';
import { t } from 'i18next';
import * as Config from 'Config';

const AUTHENTIGATE_URL = Config.AUTHENTIGATE_URL;

type CardProps = {
  children: ReactNode;
};

export const Card = ({ children }: CardProps) => {
  return (
    <div className={styles.card}>
      {children}

      <footer>
        <Stack
          direction="column"
          sx={{
            gap: 1,
            alignItems: 'center',
            textAlign: 'center'
          }}>
          <a className={styles.link} href={AUTHENTIGATE_URL} target="_blank" rel="noopener noreferrer">
            <img width={124} height={20} src={AuthentigateLogoBase64} alt="Authentigate"></img>
          </a>
          <span className={styles.footerTitle}>{`${t('form.general.footer')} SK ID Solutions`}</span>
        </Stack>
      </footer>
    </div>
  );
};
